import React from 'react';
import "./style.css";

const AppleAppStoreApp = () => {
    return (
        <a
            href="https://apps.apple.com/pl/app/qsafe24-mobile/id1499361775?mt=8"
            target="_blank"
            rel="noopener noreferrer"
            className="storeIcon appleBadge"
        >
        </a>
    );
};

export default AppleAppStoreApp;
